import type { IConfirmDocumentClassificationParams, IFindUserTasksQuery, IUserTask } from '@condo/domain';
import { getClient } from '@/api/api-client';

export const fetchUserTasks = async (params?: IFindUserTasksQuery): Promise<{ userTasks: IUserTask[]; total: number }> => {
    const { data } = await getClient('basecamp').get<{ userTasks: IUserTask[]; total: number }>('/user-tasks', {
        params: params ?? {},
    });
    return data;
};

export const fetchUserTask = async (userTaskId: number): Promise<IUserTask> => {
    const { data } = await getClient('basecamp').get<{ userTask: IUserTask }>(`/user-task/${userTaskId}`);
    return data.userTask;
};

export const confirmDocumentClassification = async (params: IConfirmDocumentClassificationParams): Promise<IUserTask> => {
    const { userTaskId, ...body } = params;
    const { data } = await getClient('basecamp').put<{ userTask: IUserTask }>(`/user-task/${userTaskId}/classify-document/user-confirmation`, body);
    return data.userTask;
};
